export const styles = {
    '@keyframes fadeFromRight': {
        from: {
            opacity: 0,
            transform: 'translateX(100%)',
        },
        to: {
            opacity: 1,
            transform: 'translateX(0)',
        },
    },
    '@keyframes fadeToRight': {
        from: {
            opacity: 1,
            transform: 'translateX(0)',
        },
        to: {
            opacity: 1,
            transform: 'translateX(100%)',
        },
    },
    container: {
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: '1000',
        width: '100%',
        height: '100%',
        marginLeft: '0',
        display: 'block',
        backgroundColor: 'white',
        animation: 'fadeFromRight .2s ease-in-out',
    },
    containerClosed: {
        animation: 'fadeToRight .2s ease-in-out',
        animationFillMode: 'forwards',
    },
    closeButton: {
        height: 29,
        width: 29,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: '0',
        border: 'none',
        backgroundColor: '#D2D2EA',
        borderRadius: '50%',
        cursor: 'pointer',
    },
    header: {
        height: '46px',
        width: '100%',
        padding: '13px 11px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: '1px solid #E3E3E3',
        boxSizing: 'border-box',
    },
    title: {
        margin: 0,
        width: '100%',
        fontWeight: 600,
        fontSize: '14px',
        textAlign: 'left',
        color: '#313140',
        borderRight: 0,
        boxSizing: 'border-box',
    },
};

export type ComponentJSSClasses = JSSClasses<typeof styles>;
